import { InvoicesService, IInvoiceComparison } from "../../services/index";
import * as moment from "moment";

class QuotationsComparisonController implements ng.IComponentController {

    private startDate: any;
    private endDate: any;
    private comparisons: IInvoiceComparison[];
    private moment: any;
    private loading: boolean;
    private totalCurrent: number;
    private totalRecalculated: number;
    private totalDifference: number;

    constructor(
        private InvoicesService: InvoicesService,
        private $scope: ng.IScope
    ) {
        "ngInject";
    }

    public $onInit = () => {
        this.moment = require("moment");
        this.comparisons = [];
        this.loading = false;
        this.totalCurrent = 0;
        this.totalRecalculated = 0;
        this.totalDifference = 0;
        this.startDate = this.moment().startOf("month").toDate();
        this.endDate = this.moment().endOf("month").toDate();
    };

    getComparison() {
        this.loading = true;
        this.InvoicesService.getComparison(this.startDate, this.endDate).then((result: IInvoiceComparison[]) => {
            this.comparisons = result || [];
            this.totalCurrent = this.comparisons.reduce((sum, c) => sum + (c.currentTotal || 0), 0);
            this.totalRecalculated = this.comparisons.reduce((sum, c) => sum + (c.recalculatedTotal || 0), 0);
            this.totalDifference = this.comparisons.reduce((sum, c) => sum + (c.difference || 0), 0);
            this.loading = false;
        }).catch(() => {
            this.loading = false;
        });
    }

    prevMonth() {
        this.startDate = this.moment(this.startDate).subtract(1, "month").startOf("month").toDate();
        this.endDate = this.moment(this.endDate).subtract(1, "month").endOf("month").toDate();
    }

    nextMonth() {
        this.startDate = this.moment(this.startDate).add(1, "month").startOf("month").toDate();
        this.endDate = this.moment(this.endDate).add(1, "month").endOf("month").toDate();
    }
}

export const quotationsComparisonComponent: ng.IComponentOptions = {
    controller: QuotationsComparisonController,
    template: require("./quotations.comparison.html")
};



// WEBPACK FOOTER //
// ./src/app/modules/quotations/quotations.comparison.component.ts